<template>
    <router-link to="/chat" class="brand">
        <img :src="logoSrc" alt="Автомаркетолог" class="brand-logo" />
        <span class="brand-tag">AI-АНАЛИТИК</span>
    </router-link>
</template>

<script setup>
import LogoImage from '@/assets/images/am_logo 1.svg'

const logoSrc = LogoImage
</script>

<style scoped>
.brand {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 4px;
    text-decoration: none;
    color: inherit;
    padding: 6px 4px;
}

.brand-logo {
    display: block;
    width: 100%;
    max-width: 220px;
    height: auto;
}

.brand-tag {
    font-size: 9.5px;
    color: #888888;
    letter-spacing: 1px;
    font-weight: 600;
    padding-left: 2px;
}
</style>
